import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { selectNotEnoughResourcesTotalGoldCost } from "../../../selectors/selectNotEnoughResources";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionNotEnoughResourceBuyWithGoldConfirm, TypeActionNotEnoughResource, } from "../actionNotEnoughResource";
// TODO:May be refactored to path
export var epicNotEnoughResourceBuyWithGold = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGold), switchMap(function (action) {
        var state = state$.value;
        var missingResources = action.missingResources;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var playerGoldAmount = !playerGoldInfo ? Long.ZERO : playerGoldInfo.amount;
        var totalGoldCost = missingResources.reduce(function (totalGold, item) {
            var resourceInfo = selectResourceInfo(item.typeId);
            var missingItems = item.amount;
            var resourceGoldValue = resourceInfo.goldValue.amount;
            var resourceTotalGoldCost = selectNotEnoughResourcesTotalGoldCost(missingItems, resourceGoldValue);
            return totalGold.add(resourceTotalGoldCost);
        }, Long.ZERO);
        return of(actionBeginBuyWithGoldProcess(playerGoldAmount || Long.ZERO, totalGoldCost, actionNotEnoughResourceBuyWithGoldConfirm(missingResources)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/epics/epicNotEnoughResourceBuyWithGold.ts
// module id = 2022
// module chunks = 3